import { resetProjectStatus } from "../../core/code/loader";
import { SHARE_PROJECT_STATE } from "../../core/constants";
import { getDomainCfg, store } from "../../core/state";
import { CloudData, CloudUser, ProjectListData } from "../../core/types";
import { getComponentData, setComponentData } from "../../core/views";

export const CLOUD_STATE = "cloudStorageData";
export const CLOUD_USER = "cloudUser";
export const CLOUD_PROJECT_LIST = "projectList";

export const initCloudState = () : void => {
  store.setState(CLOUD_USER, {
    loggedIn : false,
    userName : null,
    name : null,
    nonce : null,
    userCaps : null,
    error : null,
  });

  store.setState(CLOUD_STATE, { });
  store.setState(CLOUD_PROJECT_LIST, { });
}

export const clearCloudSession = () : void => {
  const cloudUser = getCloudUser();
  cloudUser.nonce = undefined;
  cloudUser.userName = "";
  cloudUser.name = undefined;
  cloudUser.userCaps = undefined;
  cloudUser.loggedIn = false;
  cloudUser.error = undefined;
  setCloudUser(cloudUser);

  setCloudData({
     assets:"",
     assetsKey:"",
     cloudStateLoaded : false,
     code:"",
     deleted: false,
     initCode:"",
     initKey:"",
     loaded:false,
     projectAssets:"",
     replaceKey:"",
     sources:"",
     tabs:[],
     templateCode:""
  });

  setCloudProjectList({ list : [] });
  resetProjectStatus();
}

export const getCloudUser = () : CloudUser => {
  return getComponentData(CLOUD_USER);
}

export const setCloudUser = (data : CloudUser) : void => {
  setComponentData(CLOUD_USER, data);
}

export const isUserLoggedIn = () : boolean => {
  const cloudUser = getCloudUser();
  if (!cloudUser) {
    return false;
  }
  return cloudUser.loggedIn;
}

export const getCloudData = () : CloudData => {
  return getComponentData(CLOUD_STATE);
}

export const setCloudData = (data : CloudData) : void => {
  setComponentData(CLOUD_STATE, data);
}

export const getCloudProjectList = () : ProjectListData => {
  return getComponentData(CLOUD_PROJECT_LIST);
}

export const setCloudProjectList = (data: ProjectListData) => {
  return setComponentData(CLOUD_PROJECT_LIST, data);
}

export const hashCode = (str : string) : number => {
  let hash = 0;
	if (str.length === 0) {
    return hash;
  }

	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = ((hash<<5)-hash)+char;
		hash = hash & hash; // Convert to 32bit integer
  }

	return hash;
}

export const getCloudServerPath = () : string => {
  const domainCfg = getDomainCfg();
  return domainCfg.serverSettings.baseUrl + domainCfg.serverSettings.path;
}

export const serverFeatureAvailable = () : boolean => {
  const domainCfg = getDomainCfg();
  if (domainCfg.serverSettings && domainCfg.viewSettings.features.cloudStorageAvailable) {
    return true;
  }

  return false;
}

export function buildPublicUrl(cloudId? : string) {
  const projectShareData = getComponentData(SHARE_PROJECT_STATE);
  const publicId = cloudId ? cloudId : projectShareData.shareId
  return getDomainCfg().baseUrl + getDomainCfg().viewSettings.launchView + "?sp=" + publicId;
}
